import { Input, Select } from "@frui.ts/bootstrap";
import { observer } from "mobx-react-lite";
import React from "react";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import type MunicipalityDetailViewModel from "viewModels/timeCharges/distributorEnums/municipalities/municipalityDetailViewModel";
import type MunicipalityCreateViewModel from "viewModels/timeCharges/distributorEnums/municipalities/municipalityCreateViewModel";
import FormGroup from "controls/formGroup";
import FormLabel from "controls/formLabel";

export interface MunicipalityFormProps {
  vm: MunicipalityDetailViewModel | MunicipalityCreateViewModel;
  children?: React.ReactNode;
}

const MunicipalityForm = observer((props: MunicipalityFormProps) => {
  const { vm, children } = props;
  const disabled = !vm.isEditable;

  return (
    <>
      <Form.Row>
        <FormGroup as={Col} md={6} target={vm.item} property="name">
          <FormLabel>{vm.translateAttribute("name")}</FormLabel>
          <Input disabled={disabled} />
        </FormGroup>
        <FormGroup as={Col} md={6} target={vm.item} property="regionId">
          <FormLabel>{vm.translateAttribute("regionId")}</FormLabel>
          <Select items={vm.regionOptions} mode="key" disabled={disabled} />
        </FormGroup>
      </Form.Row>
      <Form.Row>
        <FormGroup as={Col} md={6} target={vm.item} property="internalIdent">
          <FormLabel>{vm.translateAttribute("internalIdent")}</FormLabel>
          <Input disabled={disabled} />
        </FormGroup>
      </Form.Row>
      {children}
    </>
  );
});

export default MunicipalityForm;
